import i18next from 'i18next';

export const getMessage = (currentUser, showWelcomeMessage) =>
  currentUser
    ? i18next.t(`CompleteProfile:${showWelcomeMessage ? 'hello' : '{{name}}'}`, {
        name: currentUser.name
      })
    : i18next.t('CompleteProfile:login');
